import type { ThemeConfig } from "antd";
import colors from "./colors";

export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: colors.primary,
    colorPrimaryText: colors.slate[800],
    colorBorder: colors.slate[200],
    colorBgContainerDisabled: colors.primary,
  },
  components: {
    Button: {
      borderRadius: 6,
      borderRadiusSM: 6,
      borderRadiusLG: 8,

      controlHeight: 38,
      controlHeightSM: 32,
      controlHeightLG: 46,

      paddingInline: 15,
      colorPrimaryBg: colors.primary,
      colorPrimaryBgHover: colors.primary,
      colorPrimaryActive: colors.primary,
      colorBgContainerDisabled: colors.slate[500],
      primaryShadow: "none",
    },
    Form: {
      colorError: colors.error[500],
      labelColor: colors.slate[700],
    },

    Input: {
      borderRadius: 6,
      controlHeight: 38,
      borderRadiusSM: 4,
      controlHeightSM: 32,
      borderRadiusLG: 6,
      controlHeightLG: 46,

      colorBorder: colors.gray[100],
      hoverBorderColor: colors.gray[100],
      activeBorderColor: colors.gray[100],
      colorErrorBorderHover: colors.error[500],
      colorBgContainer: colors.gray[98],

      colorText: colors.slate[800],
      colorIcon: colors.gray[60],
      colorError: colors.error[500],
      colorTextPlaceholder: colors.slate[400],
      colorBgContainerDisabled: colors.slate[25],
      colorTextDisabled: colors.slate[600],
    },
    InputNumber: {
      borderRadius: 6,
      controlHeight: 38,
      borderRadiusSM: 4,
      controlHeightSM: 32,
      borderRadiusLG: 6,
      controlHeightLG: 46,

      colorBorder: colors.gray[100],
      hoverBorderColor: colors.gray[100],
      activeBorderColor: colors.gray[100],
      colorErrorBorderHover: colors.error[500],
      colorBgContainer: colors.gray[98],

      colorText: colors.slate[800],
      colorIcon: colors.gray[60],
      colorError: colors.error[500],
      colorTextPlaceholder: colors.slate[400],
      colorBgContainerDisabled: colors.slate[25],
      colorTextDisabled: colors.slate[600],
    },
    Select: {
      borderRadius: 6,
      controlHeight: 38,
      borderRadiusSM: 4,
      controlHeightSM: 32,
      borderRadiusLG: 6,
      controlHeightLG: 46,

      colorBorder: colors.gray[100],
      hoverBorderColor: colors.gray[100],
      activeBorderColor: colors.gray[100],
      colorErrorBorderHover: colors.error[500],
      colorBgContainer: colors.gray[98],

      colorText: colors.slate[800],
      colorIcon: colors.gray[60],
      colorError: colors.error[500],
      colorTextPlaceholder: colors.slate[400],
      colorBgContainerDisabled: colors.slate[25],
      colorTextDisabled: colors.slate[600],
    },
    DatePicker: {
      borderRadiusSM: 4,
      controlHeightSM: 32,
      borderRadius: 6,
      controlHeight: 38,
      borderRadiusLG: 6,
      controlHeightLG: 46,

      colorBorder: colors.gray[100],
      hoverBorderColor: colors.gray[100],
      activeBorderColor: colors.gray[100],
      colorErrorBorderHover: colors.error[500],
      colorBgContainer: colors.gray[98],

      colorText: colors.slate[800],
      colorIcon: colors.gray[60],
      colorError: colors.error[500],
      colorTextPlaceholder: colors.slate[400],
      colorBgContainerDisabled: colors.slate[25],
      colorTextDisabled: colors.slate[600],
    },
    Checkbox: {
      colorText: colors.slate[800],
      // colorBorder: colors.displayMedium,
      colorBgContainerDisabled: colors.slate[25],
    },
    Badge: {
      lineWidth: 1.5,
    },
    Menu: {
      fontSize: 16,
      itemHeight: 38,
      itemMarginBlock: 4,
      itemBorderRadius: 8,
      itemMarginInline: 16,
      itemPaddingInline: 0,
      itemHoverBg: "transparent",
      subMenuItemBg: colors.slate[25],
      itemHoverColor: colors.gray[2],
      itemActiveBg: colors.gray[94],
      itemSelectedBg: colors.gray[94],
      itemColor: colors.gray[500],
    },
    Layout: {
      bodyBg: "white",
    },
    Table: {
      borderRadiusLG: 8,
      fontSize: 14,
      colorTextHeading: colors.gray[2],
      colorText: colors.gray[24],
      colorBorderSecondary: colors.slate[100],
      colorBgContainer: "white",
      padding: 12,
    },
    Pagination: {
      itemActiveBg: colors.primary,
      itemSize: 32,
      borderRadius: 4,
      colorText: colors.gray[50],
      fontSize: 13,
    },
  },
};
